/**
 * The words and the rule for a lot's delivery document (DOCS-MENU, BD-372, 10cf A). DOCS-MENU creates this module; NO-DOC-WORDING reuses it. Never write these words a second time.
 * The farm's own count (herd lists, "Farm reports") never delivers a lot.
 */
export const NO_DELIVERY_DOCUMENT = "No delivery document on file";
export const FARM_REPORTS = "Farm reports";
export const DELIVERED = "Delivered";
/** INTERIM wording (10cf A): the invoice has a linked delivery note that names no lot of it. Counted apart: never delivered, never in the gap. */
export const DELIVERY_DOCUMENT_LOTS_NOT_NAMED = "Delivery document on file, lots not named: to check";

const DELIVERY_DOCUMENT_KINDS = new Set(["delivery_note", "delivery note", "rk_receipt_note", "rk receipt note"]);
/** True for a supplier delivery note and an RK receipt note (the code or the people's words); false for everything else. */
export function isDeliveryDocumentKind(kind: unknown): boolean {
  return typeof kind === "string" && DELIVERY_DOCUMENT_KINDS.has(kind.trim().toLowerCase());
}

export type LotDeliveryFacts = { delivery_document: boolean | null | undefined; farm_reports?: boolean | null; lots_not_named?: boolean | null };
export type LotDeliveryState = {
  state: "delivered" | "no_document" | "lots_not_named" | "unknown";
  label: string | null;
  farmReports: boolean;
};

/** The per-lot state. A failed read, or an unknown fact, shows neither wording. */
export function lotDeliveryDocumentState(facts: LotDeliveryFacts | null | undefined, opts?: { readFailed?: boolean }): LotDeliveryState {
  if (opts?.readFailed || !facts) return { state: "unknown", label: null, farmReports: false };
  const farmReports = facts.farm_reports === true;
  if (facts.delivery_document === true) return { state: "delivered", label: DELIVERED, farmReports };
  if (facts.delivery_document === false) {
    if (facts.lots_not_named === true) return { state: "lots_not_named", label: DELIVERY_DOCUMENT_LOTS_NOT_NAMED, farmReports };
    return { state: "no_document", label: NO_DELIVERY_DOCUMENT, farmReports };
  }
  return { state: "unknown", label: null, farmReports };
}
